<template>
  <b-card class="mobile-card">
    <b-container v-b-toggle="`caracs_${item.idKerhis}`">
      <b-row align-v="center">
        <b-col cols="auto" class="bg-light bg-left font-up" style="width: 80px">
          <div v-if="item.dateAnalyse" class="w-100">
            {{ jour }}/{{ mois }}<br />
            {{ annee }}
          </div>
        </b-col>
        <b-col>
          <b-row class="m-0" align-v="center">
            <b-col class="p-0">
              <div>{{ libelleProduit }}</div>
              <div v-if="datePrelevement" class="font-down">
                Ech. du {{ datePrelevement }}
              </div>
              <b-collapse
                :id="`caracs_${item.idKerhis}`"
                class="label font-down text-center"
                visible
              >
                <b-icon-chevron-down></b-icon-chevron-down>
                Caract&eacute;ristiques
              </b-collapse>
            </b-col>
            <b-col cols="auto" @click.stop>
              <DownloadComponent
                v-if="item.pieceJointe"
                :typeDocument="typeDocument"
                :targetId="item.idKerhis"
              ></DownloadComponent>
            </b-col>
          </b-row>
          <b-collapse :id="`caracs_${item.idKerhis}`" class="font-down">
            <b-row v-if="item.lieuStockageTas" class="m-0 mt-2">
              <b-col class="p-0">
                <b-icon-geo-alt></b-icon-geo-alt>
                {{ item.lieuStockageTas }}
              </b-col>
            </b-row>
            <b-row class="m-0 mt-2">
              <b-col cols="2" class="p-0">Lot</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.quantiteContrat"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                t
              </b-col>
              <b-col cols="2" class="p-0">PS</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.poidsSpecifique"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                kg/hL
              </b-col>
              <b-col cols="2" class="p-0">Hum.</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.tauxHumidite"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                %
              </b-col>
              <b-col cols="2" class="p-0">Imp.</b-col>
              <b-col cols="4" class="p-0">
                <MontantComponent
                  :value="item.tauxImpurete"
                  :options="{ minimumFractionDigits: 0 }"
                ></MontantComponent>
                %
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import MontantComponent from "../MontantComponent.vue";
import DownloadComponent from "../controls/DownloadComponent.vue";
import UtilsService from "../../services/utils.service";
export default {
  name: "AnalyseMoissonCard",
  components: { MontantComponent, DownloadComponent },
  props: ["item"],
  data() {
    return {
      typeDocument: this.$store.state.expl.typesDocument.ANALYSE_MOISSON,
    };
  },
  computed: {
    jour() {
      return this.item.dateAnalyse?.split("-")[2];
    },
    mois() {
      return this.item.dateAnalyse?.split("-")[1];
    },
    annee() {
      return this.item.dateAnalyse?.split("-")[0];
    },
    libelleProduit() {
      return (
        this.$store.getters["ref/produitCereale"](this.item.codeProduit)
          ?.libelle ?? this.item.codeProduit
      );
    },
    datePrelevement() {
      return UtilsService.isoSqlDateToFrenchDate(this.item.datePrelevement);
    },
  },
};
</script>
